import React from 'react';

interface IState {
  hasError: boolean;
}
class NullErrorBoundary extends React.Component<
  React.PropsWithChildren<{
    onErrorBoundaryCatch?: (error: Error, errorInfo: React.ErrorInfo) => void;
  }>,
  IState
> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    const { onErrorBoundaryCatch } = this.props;

    if (typeof onErrorBoundaryCatch === 'function') {
      onErrorBoundaryCatch(error, errorInfo);
    }
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return null;
    }

    return children;
  }
}

export default NullErrorBoundary;
